module.exports = __webpack_public_path__ + "img/special-offer.e7956efc.png";